// ---------------------------------------------------------------------------
// Sprint 3 A9: Conversation Tags
// ---------------------------------------------------------------------------

import { pgTable, uuid, text, timestamp, index, uniqueIndex } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

/** Tag definitions — tenant-scoped */
export const conversationTagDefinitions = pgTable(
  "conversation_tag_definitions",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    name: text("name").notNull(),
    color: text("color").default("#6B7280"), // hex color for UI badge
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    uniqueIndex("uq_conv_tag_defs_tenant_name").on(table.tenantId, table.name),
  ],
);

/** Tag applications — many-to-many between conversations and tag definitions */
export const conversationTagApplications = pgTable(
  "conversation_tag_applications",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    conversationId: uuid("conversation_id").notNull(),
    tagId: uuid("tag_id").notNull(),
    appliedBy: text("applied_by").notNull(), // userId
    appliedAt: timestamp("applied_at", tz).notNull().defaultNow(),
  },
  (table) => [
    uniqueIndex("uq_conv_tag_apps").on(table.conversationId, table.tagId),
    index("idx_conv_tag_apps_tenant").on(table.tenantId),
    index("idx_conv_tag_apps_conversation").on(table.conversationId),
    index("idx_conv_tag_apps_tag").on(table.tenantId, table.tagId),
  ],
);
